<div
  class="flex items-center justify-center min-h-[100dvh] w-[100dvw] bg-[url('/assets/images/landscapebg.jpeg')] bg-cover bg-no-repeat">
  <div
    class="w-[min(440px,calc(100%-2rem))] m-6 p-[clamp(2rem,6vw,3rem)] bg-gray-50 rounded-[1.25rem] shadow-xl min-h-[min(400px,85vh)] flex justify-center gap-4 relative">
    <div class="text-center mb-10">
      <div class="flex items-center justify-center mb-8 w-full">
        <img src="assets/images/bannerlogo.png" alt="Progres Logo" class="p-3.5 w-auto max-w-full object-contain" />
      </div>

      <div class="relative text-center my-8 h-px bg-gray-300"></div>

      @if (loading()) {
      <div class="flex items-center justify-center">
        <div class="h-5 w-5 animate-spin rounded-full border-2 border-zinc-300 border-t-zinc-900"></div>
        <p class="ml-1 font-body text-md text-gray-500">
          Verificando email. No cierres la ventana.
        </p>
      </div>
      }
      @if (!loading()) {
      <div class="flex items-center justify-center">

        <lib-icon name="check-mark"></lib-icon>
        <p class="ml-1 font-body text-md text-gray-500">
          Correo validado.
        </p>
      </div>

      <button type="button" (click)="goToSignin()" class="absolute bottom-10 left-1/2 -translate-x-1/2
         text-sm font-body font-medium text-blue-600 hover:text-blue-700 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 rounded">
        Ir a inicio de sesión
      </button>
      }
    </div>

  </div>
</div>